import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner", "reveal"]

  static values = {
    key: String,
  }

  connect() {
    this.setDismissed(this.dismissed())
  }

  dismiss(event) {
    event.preventDefault()
    this.rememberDismissal()
    this.setDismissed(true)
  }

  reveal(event) {
    event.preventDefault()
    this.forgetDismissal()
    this.setDismissed(false)
  }

  storageKey() {
    return this.hasKeyValue ? this.keyValue : "dismissible-banner"
  }

  dismissed() {
    try {
      return window.localStorage.getItem(this.storageKey()) === "dismissed"
    } catch (_error) {
      return false
    }
  }

  rememberDismissal() {
    try {
      window.localStorage.setItem(this.storageKey(), "dismissed")
    } catch (_error) {
      // The banner still hides for the current page if storage is unavailable.
    }
  }

  forgetDismissal() {
    try {
      window.localStorage.removeItem(this.storageKey())
    } catch (_error) {
      // Showing the banner still works for the current page.
    }
  }

  setDismissed(isDismissed) {
    if (this.hasBannerTarget) {
      this.bannerTarget.hidden = isDismissed
    } else {
      this.element.hidden = isDismissed
    }

    if (this.hasRevealTarget) {
      this.revealTarget.hidden = !isDismissed
    }
  }
}
